var _path, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoConnection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 55.69 5.03-5.02 4.3 4.3-5.02 5.03",
    fill: "#b8c3d5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#edae65",
    height: 4.06,
    rx: 1,
    transform: "matrix(.707 .707 -.707 .707 35.27 -5.36)",
    width: 24.37,
    x: 11.92,
    y: 37.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.89 56.07-6.55-1.09-4.31-4.31-1.09-6.55c-.22-1.29.21-2.61 1.13-3.54l6.42-6.42 14.36 14.36-6.42 6.42c-.93.93-2.25 1.35-3.54 1.13z",
    fill: "#536882"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.15 24.62h.06c1.1 0 2 .9 2 2v9.17h-4.06v-9.17c0-1.1.9-2 2-2z",
    fill: "#d3dce5",
    transform: "matrix(.707 .707 -.707 .707 28.73 -8.96)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m33.76 33.24h.06c1.1 0 2 .9 2 2v9.17h-4.06v-9.17c0-1.1.9-2 2-2z",
    fill: "#d3dce5",
    transform: "matrix(.707 .707 -.707 .707 37.35 -12.53)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#edae65",
    height: 4.06,
    rx: 1,
    transform: "matrix(-.707 -.707 .707 -.707 51.07 69.36)",
    width: 24.37,
    x: 27.71,
    y: 22.07
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m44.11 7.93 6.55 1.09 4.31 4.31 1.09 6.55c.22 1.29-.21 2.61-1.13 3.54l-6.42 6.42-14.36-14.36 6.42-6.42c.93-.93 2.25-1.35 3.54-1.13z",
    fill: "#536882"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m60 8.31-5.03 5.02-4.3-4.3 5.02-5.03",
    fill: "#b8c3d5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d3dce5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.58 45.58c-.26 0-.51-.1-.71-.29l-2.87-2.87c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l2.87 2.87c.39.39.39 1.02 0 1.41-.2.2-.45.29-.71.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.98 39.16c-.14 0-.27-.03-.41-.09l-3.71-1.65c-.5-.22-.73-.82-.51-1.32.23-.5.82-.73 1.32-.51l3.71 1.65c.5.22.73.82.51 1.32-.17.37-.53.59-.92.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.16 49.98c-.38 0-.75-.22-.92-.59l-1.65-3.71c-.22-.5 0-1.1.51-1.32.5-.22 1.1 0 1.32.51l1.65 3.71c.22.5 0 1.1-.51 1.32-.13.06-.27.09-.41.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.29 18.29c-.26 0-.51-.1-.71-.29l-2.87-2.87c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l2.87 2.87c.39.39.39 1.02 0 1.41-.2.2-.45.29-.71.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.49 14.73c-.38 0-.75-.22-.91-.59l-1.65-3.71c-.22-.5 0-1.1.51-1.32.51-.23 1.1 0 1.32.51l1.65 3.71c.22.5 0 1.1-.51 1.32-.13.06-.27.09-.41.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.73 23.49c-.14 0-.27-.03-.41-.09l-3.71-1.65c-.5-.22-.73-.81-.51-1.32.23-.5.81-.73 1.32-.51l3.71 1.65c.5.22.73.81.51 1.32-.17.37-.53.59-.91.59z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnection);
export default __webpack_public_path__ + "static/media/no-connection.a019f9d0cd50c55345b8771596882f96.svg";
export { ForwardRef as ReactComponent };